export const DEFAULT_VALUES = {
  arrange: 'Stack' as const,
  calendars: 2 as const,
  spacing: 3 as const,
  maxRangeDays: undefined,
  startText: 'From',
  endText: 'To',
  closeOnSelect: true,
  disabled: false,
  disablePast: false,
  weekendOnly: false
}

export const ERROR_MESSAGES = {
  maxDate: (date: Date, fieldName: string) =>
    `Please select a ${fieldName} date before ${date.toLocaleDateString(navigator.language)}`,
  minDate: (date: Date, fieldName: string) =>
    `Please select a ${fieldName} date after ${date.toLocaleDateString(navigator.language)}`,
  invalidDate: (fieldType: 'start' | 'end') => 
    `${fieldType === 'start' ? 'Start' : 'End'} date is not valid`,
  disableFuture: (fieldName: string) => 
    `Please select a ${fieldName} date in the past`,
  disablePast: (fieldName: string) => 
    `Please select a ${fieldName} date in the future`,
  exceedsMaxRange: (maxDays: number) => 
    `Date range cannot exceed ${maxDays} days`,
  wrongOrder: 'End date must be after start date',
  required: 'Required'
}

export const DAY_SLOT_STYLES = {
  sx: {
    '&.MuiPickersDay-today.MuiButtonBase-root:not(.Mui-selected)': {
      border: '1px solid rgba(32,197,160,0.3)',
      backgroundColor: 'rgba(32,197,160,0.3)',
    },
    '&.Mui-disabled': {
      color: 'rgba(0,0,0,0.2)',
    },
  }
}

export const FIELD_SEPARATOR_STYLES = {
  sx: { display: "none" }
}